import styled from 'styled-components';
export const LoadingContainer = styled.div `
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.loginBGColor};
`;
export const LogoContainer = styled.div `
  margin-bottom: ${(props) => props.marginBottom || '64px'};
  width: 100%;
`;
export const StyledLogo = styled.img `
  width: 100%;
  transform: scale(${(props) => props.scale || 0.75});
  @media ${(props) => props.theme.device.tablet} {
    transform: none;
  }
`;
export const CenteredSquare = styled.div `
  width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${(props) => props.theme.loginBoxBGColor};
  border-radius: 10px;
  padding: 40px;
  border: ${(props) => props.theme.loginBorder};
  @media ${(props) => props.theme.device.tablet} {
    width: 100%;
    padding: 0px;
  }
`;
export const LogoutContainer = styled.div `
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 16px 32px;
  position: absolute;
  top: 0;
  right: 0;
`;
